export default {
  isOpsZoneShouldBePrefilled: true,
  isNightCardsSupport: false,
  opsZoneMapFill: 'rgb(51, 136, 255, 0.2)',
  opsZoneMapStroke: '',
  communeMapFill: '',
  communeMapStroke: '',
  nightCardProgramInfoUrl: 'https://www.example.com/night-card',
  isAnimalsFeatureShown: false,
  languages: ['en', 'de', 'fr'],
  defaultLanguage: 'en',
  extendedCookieSupport: true,
};
